import {LATLONGLAYER} from './LatLongLayerTypes'

const initialState = {
    latLongLayer : {
        lat: Number,
        lng : Number
    }
}

const LatLongLayerReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case LATLONGLAYER:
            
            return {
                latLongLayer : action.load
            }
    
        default:
          return state
    }

}

export default LatLongLayerReducer;